/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text, UnstyledButton } from "@/shared/ui";
import { performSignout } from "@/context/authentication-signout";
import { getStoredSupportSession } from "./support-session";

/**
 * Fixed reminder, on every page, that K4D support is inside a customer's
 * account: as whom, opened by whom, why, and whether changes are allowed.
 */
export const SupportSessionBanner: React.FC = () => {
  const { t } = useTranslation("features/support-access");
  const [session] = useState(getStoredSupportSession);
  if (!session) return null;

  return (
    <div
      role="status"
      className="fixed left-1/2 top-[var(--space-1)] z-10000 flex max-w-[calc(100vw-2*var(--space-4))] -translate-x-1/2 items-center gap-[var(--space-3)] rounded-[var(--radius-full)] border border-[var(--status-warning-border)] bg-[var(--status-warning-bg)] py-[var(--space-1)] pl-[var(--space-4)] pr-[var(--space-1)] shadow-[var(--shadow-md)]"
    >
      <div className="flex min-w-0 flex-col">
        <Text component="span" className="text-sm text-[var(--status-warning-text)] [font-weight:var(--font-semibold)]">
          {t(session.canWrite ? "banner.as" : "banner.asReadOnly", { customer: session.customer })}
        </Text>
        <Text component="span" className="truncate text-xs text-[var(--status-warning-text)]" title={session.reason}>
          {t("banner.detail", { staff: session.staff, reason: session.reason })}
        </Text>
      </div>
      <UnstyledButton
        onClick={() => void performSignout()}
        className="shrink-0 rounded-[var(--radius-full)] bg-[var(--status-warning)] px-[var(--space-3)] py-[var(--space-1)] text-sm text-[var(--text-inverse)] [font-weight:var(--font-semibold)]"
      >
        {t("banner.exit")}
      </UnstyledButton>
    </div>
  );
};
